// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Radio_v-application_3OyUJ","text-h1":"Radio_text-h1_3mqQ2","text-h2":"Radio_text-h2_1to7L","radio":"Radio_radio_308Vt"};